import type { RankingFilterState } from '../states/rankingFilter.atom';

export const GOODS_RANKING_SCREEN = 'GOODS_RANKING';

/**
 * CLICK_FILTER / APPLY_FILTER / DISPLAY_GOODS 공통 분석 파라미터
 * iOS `ProductRankingReactor.sendClickFilter/sendApplyFilter`와 동일 구성
 */
export const getCommonFilterAnalytics = (filter: RankingFilterState) => {
  const isFilteredCategory =
    filter.selectedCategory !== null || filter.selectedSubCategory !== null
      ? '1'
      : '0';
  const isFilteredAge = filter.selectedAge !== null ? '1' : '0';
  const isFilteredPeriod = filter.selectedPeriod !== null ? '1' : '0';
  const isFilteredLook = '0';

  // Android 기준: category(+subCategory 합쳐서 1), age만 카운트 (marketType / period 제외)
  const appliedFilterTabCount =
    (isFilteredCategory === '1' ? 1 : 0) + (isFilteredAge === '1' ? 1 : 0);

  // CATEGORY_* 필드: subCategory가 parent와 같은 depth(=서브 '전체' 선택)이면 parent name으로,
  // 그 외엔 subCategory > category 순으로 사용 (Android 로직과 동일)
  const subCategory = filter.selectedSubCategory;
  const category = filter.selectedCategory;
  const categoryForLog =
    subCategory !== null && subCategory.depth === category?.depth
      ? category
      : (subCategory ?? category);

  return {
    APPLIED_FILTER_TYPE: {
      PERIOD: isFilteredPeriod,
      LOOK: isFilteredLook,
      AGE: isFilteredAge,
      CATEGORY: isFilteredCategory,
    },
    APPLIED_FILTER_TAB_COUNTS: appliedFilterTabCount,
    CATEGORY_SNO: (categoryForLog?.sno ?? -1).toString(),
    CATEGORY_NAME: categoryForLog?.name ?? '전체',
    CATEGORY_DEPTH: categoryForLog?.depth ?? null,
    AGE: filter.selectedAge?.name ?? '전체 연령',
    IS_FILTERED_CATEGORY: isFilteredCategory,
    IS_FILTERED_STYLE: isFilteredLook,
    IS_FILTERED_AGE: isFilteredAge,
    PERIOD: filter.selectedPeriod?.name ?? null,
    TYPE: filter.selectedMarketType?.name ?? null,
  };
};
